module.exports = __webpack_public_path__ + "components/flag/static/square/ve-1f85fe92a61d6261002be73dcecf887a.svg";